module.exports = __webpack_public_path__ + "img/02.5a09d229.png";